<template>
  <div class="app-main-inner">
    <el-dialog
      :visible.sync="visible"
      :title="$t('ChangeCharge.details')"
      width="1300px"
      :close-on-click-modal="false"
      :show-close="false"
      class="before-and-after-comparison"
      top="10vh"
      @open="showDialog"
    >
      <div class="app-main-inner-row" style="padding: 0 0 0 10px; height: 28px;">
        <el-form :inline="true" label-width="60px" label-position="right">
          <span style="font-size: 13px;font-weight: bold;">{{ $t('ChangeCharge.modifyBefore') }}</span>
        </el-form>
      </div>
      <div id="vsPage1" class="app-main-inner-row row-grid" style="height: 120px; padding: 0;">
        <cargo-ag-grid
          key="chargeGrid1"
          :grid-params.sync="chargeBeforeGrid.gridParams"
          :grid-options="chargeBeforeGrid.gridOptions"
          :column-defs="chargeBeforeGridColumnDefs"
          :row-data="chargeBeforeRowData"
          :show-side-bar="true"
          :auto-fit-content="false"
          min-height="150"
          style="height:120px;width: 100%;"
        />
      </div>
      <div style="display: flex; justify-content: flex-end; padding-right: 10px; height: 30px; background-color: #f5f7f7;">
        <span style="font-size: 13px;" v-text="$t('ChangeCharge.estimateProfit')" />
        <div style="padding-right: 10px;display: inline-block;vertical-align: middle">
          <div style="display: flex;justify-content: space-between;">
            <div v-for="(item,index) in chargeOriginalProfit" :key="index">
              <change-charge-count-item-renderer :item="item" />
            </div>
          </div>
        </div>
      </div>
      <div class="app-main-inner-row" style="padding: 0 0 0 10px; height: 28px;">
        <el-form :inline="true" label-width="60px" label-position="right">
          <span style="font-size: 13px;font-weight: bold;">{{ $t('ChangeCharge.modifyAfter') }}</span>
        </el-form>
      </div>
      <div id="vsPage2" class="app-main-inner-row row-grid" style="height: 120px; padding: 0;">
        <cargo-ag-grid
          key="chargeGrid2"
          :grid-params.sync="chargeAfterGrid.gridParams"
          :grid-options="chargeAfterGrid.gridOptions"
          :column-defs="chargeAfterGridColumnDefs"
          :row-data="chargeAfterRowData"
          :show-side-bar="true"
          :auto-fit-content="false"
          min-height="150"
          style="height:120px;width: 100%;"
        />
      </div>
      <div style="display: flex; justify-content: flex-end; padding-right: 10px; height: 30px; background-color: #f5f7f7;">
        <span style="font-size: 13px;" v-text="$t('ChangeCharge.estimateProfit')" />
        <div style="padding-right: 10px;display: inline-block;vertical-align: middle">
          <div style="display: flex;justify-content: space-between;">
            <div v-for="(item,index) in chargeChangeProfit" :key="index">
              <change-charge-count-item-renderer :item="item" />
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; margin: 2px;">
        <el-form label-position="left" label-width="80px" style="width: 1100px;">
          <el-col :span="24">
            <el-form-item :label="$t('ChangeCharge.changeReason')">
              <el-input v-model="changeReason" :disabled="true" type="textarea" :rows="3" resize="none" no="1" />
            </el-form-item>
          </el-col>
        </el-form>
      </div>
      <div slot="footer">
        <span>
          <el-button type="primary" no="2" @click="cancel">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ChangeChargeCountItemRenderer from '@/views/cargo/v0/Clearing/components/ChangeChargeVerify/changeChargeCountItemRenderer'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'

export default {
  name: 'BeforeAndAfterComparisonDialog',
  components: { ChangeChargeCountItemRenderer },
  props: {
    visible: { type: Boolean, required: true },
    changeReason: { type: String, default: '' }, // 更改原因
    chargeBefore: { type: Array, default: () => [] }, // 修改前
    chargeAfter: { type: Array, default: () => [] }, // 修改后
    chargeOriginalProfit: { type: Array, default: () => [] }, // 整票预估利润：修改前
    chargeChangeProfit: { type: Array, default: () => [] } // 整票预估利润：修改后
  },
  data() {
    return {
      chargeBeforeGrid: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressContextMenu: true,
          suppressClipboardPaste: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          defaultColDef: {
            // sortable: false,
            // resizable: false,
            // menuTabs: []
          }
        }
      },
      chargeAfterGrid: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressContextMenu: true,
          suppressClipboardPaste: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          defaultColDef: {
            // sortable: false,
            // resizable: false,
            // menuTabs: []
          }
        }
      },
      redCellStyle: { color: 'red' }
    }
  },
  computed: {
    chargeBeforeGridColumnDefs() {
      console.log('chargeBeforeGridColumnDefs')
      const result = [
        { headerName: this.$t('FinanceManage.charge_chargeItem'), field: 'chargeItemId', width: 80,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        { headerName: this.$t('FinanceManage.charge_settleAccountsTo'), field: 'accountId', width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FinanceManage.charge_invoiceHeader'), field: 'invoiceTitle', width: 140 },
        { headerName: this.$t('FinanceManage.charge_somesticOrInternational'), field: 'oversea', width: 60,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          }
        },
        { headerName: this.$t('FinanceManage.charge_drawABillOrNot'), field: 'needInvoice', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        { headerName: this.$t('Payment.controlledOrNot'), field: 'controlled', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }
        },
        { headerName: this.$t('FinanceManage.charge_currency'), field: 'currency', width: 60 },
        { headerName: this.$t('FinanceManage.charge_exchangeRate'), field: 'exchangeRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          }
        },
        { headerName: this.$t('FinanceManage.charge_unit'), field: 'measure', width: 60,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('FinanceManage.adChargeInfo_quantity'), field: 'quantity', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          }
        },
        { headerName: this.$t('FinanceManage.charge_unitPrice'), field: 'unitRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), field: 'amount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxExcludedPrice'), field: 'excludingTaxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxRate'), field: 'taxRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        { headerName: this.$t('FinanceManage.charge_taxAmount'), field: 'taxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        },
        {
          headerName: this.$t('Invoice.invoice_financialDate'), field: 'accountingDate', colId: 'accountingDate', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('FinanceManage.charge_contactPerson'), field: 'contactPerson', width: 60 },
        { headerName: this.$t('FinanceManage.charge_remarks'), field: 'remarks', width: 140 },
        { headerName: this.$t('FinanceManage.charge_relatedBLNo'), colId: 'relatedMbl', field: 'relatedMbl', initialWidth: 180 },
        { headerName: this.$t('FinanceManage.charge_relatedContainerNo'), field: 'relationContainerNo', colId: 'relationContainerNo', width: 200 }
      ]
      if (this.$store.getters.currentOffice.whtTaxMode) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        })
      }
      return result
    },
    chargeAfterGridColumnDefs() {
      console.log('chargeAfterGridColumnDefs')
      const result = [
        { headerName: this.$t('FinanceManage.charge_chargeItem'), field: 'chargeItemId', width: 80,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }, headerClass: this.chargeItemIdCellStyle ? 'redStyle' : '', cellStyle: this.chargeItemIdCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('FinanceManage.charge_settleAccountsTo'), field: 'accountId', width: 140,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }, headerClass: this.accountIdCellStyle ? 'redStyle' : '', cellStyle: this.accountIdCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('FinanceManage.charge_invoiceHeader'), field: 'invoiceTitle', width: 140,
          headerClass: this.invoiceTitleCellStyle ? 'redStyle' : '', cellStyle: this.invoiceTitleCellStyle ? this.redCellStyle : null },
        { headerName: this.$t('FinanceManage.charge_somesticOrInternational'), field: 'oversea', width: 60,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.overseas') : this.$t('SeaExport.internal')
          }, headerClass: this.overseaCellStyle ? 'redStyle' : '', cellStyle: this.overseaCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('FinanceManage.charge_drawABillOrNot'), field: 'needInvoice', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }, headerClass: this.needInvoiceCellStyle ? 'redStyle' : '', cellStyle: this.needInvoiceCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('Payment.controlledOrNot'), field: 'controlled', width: 100,
          valueFormatter: (params) => {
            return params.value ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          }, headerClass: this.controlledCellStyle ? 'redStyle' : '', cellStyle: this.controlledCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('FinanceManage.charge_currency'), field: 'currency', width: 60,
          headerClass: this.currencyCellStyle ? 'redStyle' : '', cellStyle: this.currencyCellStyle ? this.redCellStyle : null },
        { headerName: this.$t('FinanceManage.charge_exchangeRate'), field: 'exchangeRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00000000')
          }, headerClass: this.exchangeRateCellStyle ? 'redStyle' : '', cellStyle: this.exchangeRateCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('FinanceManage.charge_unit'), field: 'measure', width: 60,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          }, headerClass: this.measureCellStyle ? 'redStyle' : '', cellStyle: this.measureCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('FinanceManage.adChargeInfo_quantity'), field: 'quantity', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }, headerClass: this.quantityCellStyle ? 'redStyle' : '', cellStyle: this.quantityCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('CargoMsg.Cargo_PaymentReceiveMethod'), field: 'receivable', width: 100, colId: 'receivable',
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          }
        },
        { headerName: this.$t('FinanceManage.charge_unitPrice'), field: 'unitRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          }, headerClass: this.unitRateCellStyle ? 'redStyle' : '', cellStyle: this.unitRateCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), field: 'amount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }, headerClass: this.amountCellStyle ? 'redStyle' : '', cellStyle: this.amountCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('FinanceManage.charge_taxExcludedPrice'), field: 'excludingTaxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }, headerClass: this.excludingTaxAmountCellStyle ? 'redStyle' : '', cellStyle: this.excludingTaxAmountCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('FinanceManage.charge_taxRate'), field: 'taxRate', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }, headerClass: this.taxRateCellStyle ? 'redStyle' : '', cellStyle: this.taxRateCellStyle ? this.redCellStyle : null
        },
        { headerName: this.$t('FinanceManage.charge_taxAmount'), field: 'taxAmount', width: 60,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }, headerClass: this.taxAmountCellStyle ? 'redStyle' : '', cellStyle: this.taxAmountCellStyle ? this.redCellStyle : null
        },
        {
          headerName: this.$t('Invoice.invoice_financialDate'), field: 'accountingDate', colId: 'accountingDate', width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('FinanceManage.charge_contactPerson'), field: 'contactPerson', width: 60,
          headerClass: this.contactPersonCellStyle ? 'redStyle' : '', cellStyle: this.contactPersonCellStyle ? this.redCellStyle : null },
        { headerName: this.$t('FinanceManage.charge_remarks'), field: 'remarks', width: 140 },
        { headerName: this.$t('FinanceManage.charge_relatedBLNo'), colId: 'relatedMbl', field: 'relatedMbl', initialWidth: 180,
          headerClass: this.relatedMblCellStyle ? 'redStyle' : '', cellStyle: this.relatedMblCellStyle ? this.redCellStyle : null },
        { headerName: this.$t('FinanceManage.charge_relatedContainerNo'), field: 'relationContainerNo', colId: 'relationContainerNo', width: 200,
          headerClass: this.relationContainerNoCellStyle ? 'redStyle' : '', cellStyle: this.relationContainerNoCellStyle ? this.redCellStyle : null }
      ]
      if (this.$store.getters.currentOffice.whtTaxMode) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 100,
          headerClass: this.whtTaxRateCellStyle ? 'redStyle' : '',
          cellStyle: this.whtTaxRateCellStyle ? this.redCellStyle : null,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 100,
          headerClass: this.whtTaxLocalAmountCellStyle ? 'redStyle' : '',
          cellStyle: this.whtTaxLocalAmountCellStyle ? this.redCellStyle : null,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        })
      }
      return result
    },
    chargeBeforeRowData() {
      return this.chargeBefore
    },
    chargeAfterRowData() {
      return this.chargeAfter
    },
    chargeItemIdCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].chargeItemId !== this.chargeAfter[0].chargeItemId) {
        return true
      } else {
        return false
      }
    },
    accountIdCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].accountId !== this.chargeAfter[0].accountId) {
        return true
      } else {
        return false
      }
    },
    invoiceTitleCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].invoiceTitle !== this.chargeAfter[0].invoiceTitle) {
        return true
      } else {
        return false
      }
    },
    overseaCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].oversea !== this.chargeAfter[0].oversea) {
        return true
      } else {
        return false
      }
    },
    needInvoiceCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].needInvoice !== this.chargeAfter[0].needInvoice) {
        return true
      } else {
        return false
      }
    },
    controlledCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].controlled !== this.chargeAfter[0].controlled) {
        return true
      } else {
        return false
      }
    },
    currencyCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].currency !== this.chargeAfter[0].currency) {
        return true
      } else {
        return false
      }
    },
    exchangeRateCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].exchangeRate !== this.chargeAfter[0].exchangeRate) {
        return true
      } else {
        return false
      }
    },
    measureCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].measure !== this.chargeAfter[0].measure) {
        return true
      } else {
        return false
      }
    },
    quantityCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].quantity !== this.chargeAfter[0].quantity) {
        return true
      } else {
        return false
      }
    },
    unitRateCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].unitRate !== this.chargeAfter[0].unitRate) {
        return true
      } else {
        return false
      }
    },
    amountCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].amount !== this.chargeAfter[0].amount) {
        return true
      } else {
        return false
      }
    },
    excludingTaxAmountCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].excludingTaxAmount !== this.chargeAfter[0].excludingTaxAmount) {
        return true
      } else {
        return false
      }
    },
    taxRateCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].taxRate !== this.chargeAfter[0].taxRate) {
        return true
      } else {
        return false
      }
    },
    taxAmountCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].taxAmount !== this.chargeAfter[0].taxAmount) {
        return true
      } else {
        return false
      }
    },
    contactPersonCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].contactPerson !== this.chargeAfter[0].contactPerson) {
        return true
      } else {
        return false
      }
    },
    relatedMblCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].relatedMbl !== this.chargeAfter[0].relatedMbl) {
        return true
      } else {
        return false
      }
    },
    relationContainerNoCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].relationContainerNo !== this.chargeAfter[0].relationContainerNo) {
        return true
      } else {
        return false
      }
    },
    whtTaxRateCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].whtTaxRate !== this.chargeAfter[0].whtTaxRate) {
        return true
      } else {
        return false
      }
    },
    whtTaxLocalAmountCellStyle() {
      if (this.chargeBefore.length > 0 && this.chargeAfter.length > 0 && this.chargeBefore[0].whtTaxLocalAmount !== this.chargeAfter[0].whtTaxLocalAmount) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    showDialog() {
      console.log('showDialog:')
      this.chargeBeforeGrid.gridOptions.api.clearFocusedCell()
      this.chargeAfterGrid.gridOptions.api.clearFocusedCell()
    },
    cancel() {
      this.$emit('onCancel')
    }
  }
}
</script>

<style lang="scss">
.before-and-after-comparison {
  .el-dialog__body {
    padding: 2px !important;
    .el-form-item {
      margin-bottom: 0!important;
    }
  }
  .ag-theme-balham {
    .ag-cell{
      user-select: text;
    }
  }
  .redStyle {
    color: red;
  }
}
</style>
